export default __webpack_public_path__ + "static/media/RMF.0c09a697.png";